import { useRef, useState } from "react";
import { notify } from "../../common/Toast";
import Button from "../../common/Button";
import { LiaSearchPlusSolid, LiaSearchSolid } from "react-icons/lia";
import { MdClose } from "react-icons/md";
import Table from "../../common/Table";
import Loader from "../../common/Loader";
import { NalcoRateAPI } from "../../utlis/apiService";

const NalcoMaster = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [isNalcoData, setIsNalcoData] = useState([]);
  const tableScrollRef = useRef(null);

  const handleFetchNalcoRate = async () => {
    setLoading(true);
    try {
      const res = await NalcoRateAPI.getAllNalcoPrice();
      setIsNalcoData(res.data || []);
    } catch (error) {
      notify("Error fetching Nalco Rate", "error");
    }
    setLoading(false);
  };

  const handleFetchIngotRate = async () => {
    setLoading(true);
    try {
      const res = await NalcoRateAPI.getAllIngotPrice();
      setIsNalcoData(res.data || []);
    } catch (error) {
      notify("Error fetching Ingot Rate", "error");
    }
    setLoading(false);
  };

  const filteredData = isNalcoData.filter((row) =>
    Object.values(row)?.some((val) =>
      String(val).toLowerCase().includes(searchQuery.toLowerCase()),
    ),
  );

  return (
    <>
      <div>
        <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4 bg-white p-4 rounded-xl shadow-sm border border-gray-100">
          <div className="flex flex-col">
            <h2 className="text-2xl font-extrabold text-gray-800 tracking-tight">
              Die Master
            </h2>
            <p className="text-sm text-gray-500">
              Manage and track your die inventory
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-3 w-full md:w-auto">
            <div className="relative w-full sm:w-72 group">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <LiaSearchSolid className="h-5 w-5 text-gray-400 group-focus-within:text-blue-500 transition-colors" />
              </div>
              <input
                type="text"
                placeholder="Search by Die No..."
                className="block w-full pl-10 pr-10 py-2.5 bg-gray-50 border border-gray-200 text-gray-900 text-sm rounded-xl focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all outline-none"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery("")}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-red-500 transition-colors"
                >
                  <MdClose size={18} />
                </button>
              )}
            </div>

            <Button
              text="Show Nalco Rate"
              onClick={handleFetchNalcoRate}
              className="bg-orange text-black font-semibold text-md rounded-md p-2"
            />
            <Button
              text="Fetch Ingot Rate"
              onClick={handleFetchIngotRate}
              className="bg-primary text-white font-semibold text-md rounded-md p-2"
            />
          </div>
        </div>
        <div
          ref={tableScrollRef}
          className="relative overflow-auto border border-slate-200 rounded-xl shadow-inner bg-white"
          style={{ height: "calc(100vh - 320px)" }}
        >
          {loading ? (
            <Loader />
          ) : filteredData.length > 0 ? (
            <Table
              columns={[
                { key: "logDate", label: "Log Date" },
                { key: "productCode", label: "Product Code" },
                { key: "nalcoPrice", label: "Nalco Price" },
                { key: "fileName", label: "File Name" },
                //   {
                //     key: "fileName",
                //     label: "File Name",
                //     render: (value) =>
                //       value ? (
                //         <a
                //           href={value}
                //           target="_blank"
                //           rel="noopener noreferrer"
                //           className="text-blue-600 hover:text-blue-800"
                //         >
                //           View File
                //         </a>
                //       ) : (
                //         <span className="text-gray-400">No File</span>
                //       ),
                //   },
              ]}
              data={filteredData}
              showActions={false}
            />
          ) : (
            <div className="text-center text-gray-400 py-8">
              No data available
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default NalcoMaster;
